import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import Utillities from '@/Utility/Utilities';
import SelectBoxItemViewModel from '@/ViewModels/Controls/SelectBoxItemViewModel';

export default class SelectBoxViewModel extends ControlViewModel {

    /**
     * Beinhaltet die selektierbaren Werte
     */
    public items: KnockoutObservable<Array<SelectBoxItemViewModel>>;

    /**
     * Beinhaltet die selektierten Werte
     */
    public value: KnockoutComputed<any>;

    /**
     * Das ViewModel für den SelectBox
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.items = this.observableOrDefault(params.items, []);
        this.value = this.definePureComputed({
            read: () => {
                let result = [];
                let items = ko.toJS(this.items);

                for (let i = 0; i < items.length; i++) {
                    if (items[i].checkBox.isChecked === true) {
                        result.push(items[i].value);
                    }
                }

                return result.join(',');
            },
            write: (values: any) => {
                values = Utillities.isNullOrUndefinedOrBlank(values) ? [] : values.split(',');
                let items = this.items();

                for (let i = 0; i < items.length; i++) {
                    let value = items[i].value();
                    let isChecked = values.indexOf(value) > -1;

                    items[i].checkBox.isChecked(isChecked);
                }
            }
        }, params.value);

        ControlViewModel.checkProperties(this, params);
    }
}

ComponentManager.setViewModel('SelectBoxViewModel', SelectBoxViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');